import { UseLuxonProps } from "@kernel/frontend-react-app";
import { IStack, Stack } from "@kernel/utils";

export interface DayPickerConfig extends UseLuxonProps {
  inputDateFormat: string;
  inputDateMask: string;
  inputDateMaskPlaceholder: string;
}

export type ConfigIntlProps = DayPickerConfig;

export interface IAppConfig {
  intl: ConfigIntlProps;
  webrtc: RTCConfiguration;
}

export interface LoaderState {
  loading: boolean;
  title?: string;
  description?: string;
  error?: boolean;
}

export interface MainState {
  config: IAppConfig | null;
  loader: IStack<LoaderState>;
  loaded: boolean;
}

export const defaultMainState: MainState = {
  config: null,
  loader: new Stack<LoaderState>([
    {
      loading: false,
      title: "",
      description: "",
      error: false
    }
  ]),
  loaded: false
};
